// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Showvehicletype() {
//   const [responseData, setResponseData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//     const [deleteId, setDeleteId] = useState(null);
//   const hiddenColumns = ["SomeHiddenColumn","ID"];

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", "abcd");
//     data.append("TableName", "VehicleTypes");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");

//     try {
//       const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
//       const apiUrl = "http://etour.responseinfoway.com/restapi/Selectdata.aspx";

//       const response = await fetch(proxyUrl + apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: data.toString(),
//       });

//       const jsonData = await response.json();

//       if (jsonData.Response) {
//         setResponseData(jsonData.Response);
//         setFilteredData(jsonData.Response);
//       } else {
//         setError("No data found.");
//       }
//     } catch (error) {
//       setError("Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmDelete = (id) => {
//   setDeleteId(id); // store ID to delete
// };

// const handleDelete = async () => {
//   if (!deleteId) return;

//   const deleteData = new URLSearchParams();
//   deleteData.append("SecurityKey", "abcd");
//   deleteData.append("TableName", "VehicleTypes"); // <-- change table name here
//   deleteData.append("WhereCondition", `ID=${deleteId}`);
//    console.log( `ID=${deleteId}`)

//   const deleteUrl =  "http://etour.responseinfoway.com/restapi/deletedata.aspx";

//   try {
//     const response = await fetch(deleteUrl, {
//       method: "POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body: deleteData.toString(),
//     });

//     if (!response.ok) {
//       throw new Error(`API error! HTTP Status: ${response.status}`);
//     }

//     const textResponse = await response.text();
//     console.log("Delete Response:", textResponse);

//     if (
//       textResponse.toLowerCase().includes("deleted") ||
//       textResponse.toLowerCase().includes("success")
//     ) {
//       toast.success("Deleted successfully!");

//       // Remove item from UI without reloading
//       setResponseData((prevData) =>
//         prevData.filter((item) => item.ID !== deleteId)
//       );
//       setFilteredData((prevData) =>
//         prevData.filter((item) => item.ID !== deleteId)
//       );
//     } else {
//       toast.success("Deleted successfully!");
//     }
//   } catch (error) {
//     console.error("Delete Error:", error);
//    toast.success("Deleted successfully!");
//   }
// };

//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <>
//       <div className="Payment_div">
//         <div className="payment_maintext">
//           <h6>VehicleType</h6>

//           <div>
//             <Link className="payment_breadcrumbs" to={"/vehicletype"}>
//               <p>VehicleType</p>
//             </Link>

//             <span>
//               <i className="fa-solid fa-chevron-right"></i>Master
//             </span>
//           </div>
//         </div>
//         <div className="button_search-payment">
//           <Link to={"/vehicletype"}>
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add VehicleType
//             </button>
//           </Link>
//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for name or designation..."
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {/*  */}

//         <div className="vehicle-type-container mb-5">
//           <ToastContainer position="top-right" autoClose={3000} />

//             <div className="search-container mt-3">
//         <div className="records-per-page-container">
//           <label htmlFor="recordsPerPage">Records Per Page:</label>
//           <select
//             id="recordsPerPage"
//               value={recordsPerPage}
//               onChange={(e) => setRecordsPerPage(Number(e.target.value))}
//           >
//             <option value="5">5</option>
//             <option value="10">10</option>
//             <option value="15">15</option>
//             <option value="20">20</option>
//           </select>
//         </div>
//       </div>

//           {loading && <p>Loading...</p>}
//           {error && <p>{error}</p>}

//           {!loading && currentRecords.length > 0 && (

//              <div className="response-container w-2/5 ">
//           <div className="table-wrapper">
//             <table className="data-table">
//               <thead >
//                 <tr >
//                   {Object.keys(currentRecords[0])
//                     .filter((key) => !hiddenColumns.includes(key))
//                     .map((key) => (
//                       <th key={key} >{key}</th>
//                     ))}
//                   <th className="w-14">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentRecords.map((item, index) => (
//                   <tr key={index}>
//                     {Object.entries(item)
//                       .filter(([key]) => !hiddenColumns.includes(key))
//                       .map(([key, value], i) => (
//                         <td key={i}>
//                           {value !== null ? value.toString() : "N/A"}
//                         </td>
//                       ))}
//                     <td>
//                       <div className="seletdata_edit-delet-btn">
//                         <Link
//                           to="/updatevehile"
//                           // state={{ responseData:item }}
//                          state={{ responseData: item }}
//                         >
//                           <button className="selet_edit-btn" title="Edit">
//                             <i className="fa-solid fa-pen-to-square"></i>
//                           </button>
//                         </Link>
//                         <button
//                           className="select_delete-btn"
//                        data-bs-toggle="modal"
//                           data-bs-target="#deleteConfirmationModal"
//                           onClick={() => confirmDelete(item.ID)}
//                         >
//                           <i className="fa-solid fa-trash"></i>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             </div>

//                 {/* Pagination Controls */}
//           <div className="select_pagination mt-4">
//             <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
//             <span>
//               &nbsp; {currentPage} of {totalPages}
//             </span>
//             <button
//               onClick={() =>
//                 setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//               }
//               disabled={currentPage === totalPages}
//             >
//               &nbsp; Next
//             </button>
//           </div>
//             </div>
//           )}

//   {/* Delete Confirmation Modal */}
//       <div className="modal fade" id="deleteConfirmationModal">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>
//             <div className="delet_icon-boxtaxes">
//               <i className="fa-solid fa-trash"></i>
//             </div>
//             <div className="taxes_pcolom">
//               <h6>Confirm Delete</h6>
//               <p>Are you sure you want to delete?</p>
//             </div>
//             <div className="close_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="delete_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//         </div>
//       </div>
//     </>
//   );
// }

// export default Showvehicletype;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";
import "../Ledger/ShowLedger.css";

function Showvehicletype() {
  const [responseData, setResponseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const hiddenColumns = ["SomeHiddenColumn", "ID", "VehicleTypeID", "VehicleTypeName", "Name"];

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setError(null);
    setLoading(true);
    setResponseData([]);

    try {
      const response = await fetch(`${BASE_API_URL}/vehicletypes`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const jsonData = await response.json();
      const records =
        jsonData.data ||
        jsonData.vehicleTypes ||
        jsonData.Response ||
        (Array.isArray(jsonData) ? jsonData : []);

      if (records && records.length > 0) {
        setResponseData(records);
        setFilteredData(records);
      } else {
        setResponseData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Failed to fetch vehicle types:", error);
      setError("Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (item) => {
    setDeleteId(item.ID || item.VehicleTypeID);
    setDeleteItemName(item.VTYPE || item.VehicleType || item.Name || `Vehicle Type #${item.ID}`);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteId) return;

    try {
      setIsDeleting(true);
      // ============================
      // API with Logging (Node)
      // ============================
      const res = await apiWithLog({
        method: "DELETE",
        url: `${BASE_API_URL}/vehicletypes/${deleteId}`, // your Node delete API
        module: "VehicleTypeMaster",
        action: "D",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;
      console.log("Delete Response:", result);

      // ============================
      // Success Check (Node)
      // ============================
      if ((res.status === 200 || res.status === 204) && (result?.status || result?.success)) {
        showToast.delete("Vehicle type deleted successfully!");

        // Update UI safely
        setResponseData((prevData) =>
          prevData.filter((item) => String(item.ID || item.VehicleTypeID) !== String(deleteId)),
        );

        setFilteredData((prevData) =>
          prevData.filter((item) => String(item.ID || item.VehicleTypeID) !== String(deleteId)),
        );
        setDeleteModalOpen(false);
      } else {
        showToast.error(result?.message || "Delete failed");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      showToast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Network error during deletion.",
      );
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
    }
  };

  const totalPages = Math.ceil(filteredData.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  return (
    <div className="ledger_page_container">
      {/* TOP HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">Vehicle Type Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Vehicle Types</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS CARD */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/vehicletype" className="new_ledger_btn">
            + Add Vehicle Type
          </Link>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search vehicle types..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={4} rows={6} hasToolbar={false} />
        )}

        {error && !loading && (
          <div className="ledger_empty_state">
            <h6>Error Loading Data</h6>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && currentRecords.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    {Object.keys(currentRecords[0])
                      .filter((key) => !hiddenColumns.includes(key))
                      .map((key) => (
                        <th key={key}>
                          {key === "VTYPE" ? "Vehicle Type" : key}
                        </th>
                      ))}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((item, index) => (
                    <tr key={index}>
                      {Object.entries(item)
                        .filter(([key]) => !hiddenColumns.includes(key))
                        .map(([key, value], i) => (
                          <td
                            key={i}
                            className={key === "VTYPE" ? "ledger_name_cell" : ""}
                          >
                            {value !== null && value !== "" ? value.toString() : "N/A"}
                          </td>
                        ))}
                      <td className="ledger_actions_cell">
                        <div className="ledger_actions_wrapper">
                          <Link
                            to="/updatevehile"
                            state={{ responseData: item }}
                          >
                            <button
                              type="button"
                              className="ledger_btn_edit"
                              title="Edit Vehicle Type"
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                          </Link>
                          <button
                            type="button"
                            className="ledger_btn_delete"
                            title="Delete Vehicle Type"
                            onClick={() => confirmDelete(item)}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {indexOfFirstRecord + 1} to{" "}
                {Math.min(indexOfLastRecord, filteredData.length)} of{" "}
                {filteredData.length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && !error && currentRecords.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Vehicle Types Found</h6>
            <p>
              {searchQuery
                ? `No vehicle types matching "${searchQuery}"`
                : "No vehicle types available."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete Vehicle Type?"
        message="Are you sure you want to delete this vehicle type?"
        itemName={deleteItemName}
        loading={isDeleting}
      />
    </div>
  );
}

export default Showvehicletype;
